// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"gttl-residents-love_imageContainer__k8jkK","textContainer":"gttl-residents-love_textContainer__n55XC"};